import { useSystemStore } from 'src/store/SystemStore';

/** Subscribe to the same running version used by requests and diagnostics. */
export function useAppVersion(): string {
  return useSystemStore((state) => state.appVersion.current);
}
